import { CSSProperties } from "react";

export const XTrashCardSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      width={width}
      height={(width / 57) * 85}
      viewBox="0 0 57 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g filter="url(#filter0_di_291_6)">
        <rect
          x="1"
          y="1"
          width="55"
          height="83"
          rx="1"
          fill="url(#trashCardGradient)"
        />
        <rect
          x="1.5"
          y="1.5"
          width="54"
          height="82"
          rx="0.5"
          stroke="white"
          strokeOpacity="0.92"
        />
      </g>
      <path
        d="M13 34.5L20 27L28 34.5L36 27L43 34.5L35 42.5L43.5 50.5L36 58L28 50.5L20 58L13 51L21 42.5L13 34.5Z"
        fill="#FFFEFE"
        stroke="black"
      />
      <defs>
        <filter
          id="filter0_di_291_6"
          x="0"
          y="0"
          width="57"
          height="85"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_291_6"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_291_6"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_291_6"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.67 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_291_6"
          />
        </filter>
        <linearGradient
          id="trashCardGradient"
          x1="28.5"
          y1="1"
          x2="28.5"
          y2="84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7A7A7A" />
          <stop offset="0.1" stopColor="#4F4F4F" />
          <stop offset="0.5" />
          <stop offset="0.9" stopColor="#4F4F4F" />
          <stop offset="1" stopColor="#7A7A7A" />
        </linearGradient>
      </defs>
    </svg>
  );
};
